// extracted by mini-css-extract-plugin
export var actions = "_4r-0";
export var actionsContainer = "_4r-7";
export var border = "_4r-1";
export var childFullHeight = "_4r-f";
export var collapse = "_4r-2";
export var content = "_4r-a";
export var contentChild = "_4r-e";
export var fullscreen = "_4r-c";
export var hasLeftRadius = "_4r-k";
export var headerContainer = "_4r-3";
export var headerRow = "_4r-5";
export var hidePadding = "_4r-b";
export var navCollapsedGap = "_4r-l";
export var noScrollX = "_4r-m";
export var noScrollY = "_4r-n";
export var noTopPadding = "_4r-i";
export var optOutTopPadding = "_4r-d";
export var pageMain = "_4r-j";
export var pageOuter = "_4r-g";
export var pagePadding = "_4r-8";
export var pageScroll = "_4r-9";
export var profile = "_4r-o";
export var profileContainer = "_4r-p";
export var profileImage = "_4r-q";
export var profileMain = "_4r-r";
export var profileSubtitle = "_4r-t";
export var profileTitle = "_4r-s";
export var showLeftPadding = "_4r-h";
export var tabsPortalSlot = "_4r-6";
export var tabsWrapper = "_4r-4";
export var title = "_4r-u";